import { AiOutlineCode, AiOutlineSetting } from "react-icons/ai";
import howToUseVideo from "../assets/howtouse.webm";
const steps = [
  {
    icon: <AiOutlineCode size={36} />,
    mainTitle: "Add the Script",
    contents: [`Add a tiny script to your site — it only takes 10 seconds.`],
  },
  {
    icon: <AiOutlineSetting size={36} />,
    mainTitle: "Start Using",
    contents: [
      "Effie instantly learns from your website and starts talking to your visitors.",
    ],
  },
];

const Step = ({ icon, mainTitle, contents }) => {
  return (
    <li
      className="
        flex flex-col items-center text-center 
        space-y-5 p-6 duration-300 
        w-full 
        h-full
      "
    >
      <div
        className="
          w-20 h-20 flex items-center justify-center
          rounded-full bg-cyan-500 dark:bg-gray-800
          transition-all duration-300
           dark:hover:bg-gray-700
        "
      >
        <span className="text-white dark:text-cyan-400 text-4xl">{icon}</span>
      </div>

      <h3
        className="
          text-gray-900 dark:text-white 
          text-xl font-semibold tracking-wide
        "
      >
        {mainTitle}
      </h3>

      <div className="space-y-2 text-gray-600 dark:text-gray-300 leading-relaxed">
        {contents.map((content, index) => (
          <p key={index} className="text-base">
            {content}
          </p>
        ))}
      </div>
    </li>
  );
};
const HowToUseEffieSection = () => {
  return (
    <>
      <section className="bg-white py-16 px-4 sm:px-6">
        <div className="max-w-5xl mx-auto text-center">
          {/* Heading */}
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-gray-800 mb-4 animate-fade-in">
            How to Use Effie
          </h2>

          {/* Subheading */}
          <p className="text-lg sm:text-xl text-gray-600 mb-10 animate-fade-in">
            A quick look at how Effie simplifies your daily workflows.
          </p>

          {/* Video */}
          <div className="relative w-full max-w-3xl mx-auto pb-[56.25%] bg-gray-900 rounded-lg overflow-hidden shadow-lg animate-fade-in">
            <video
              className="absolute top-0 left-0 w-full h-full object-contain rounded-lg"
              controls
              playsInline
              // poster={howToUseThumbnail}
            >
              <source src={howToUseVideo} type="video/webm" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        {/* Animation Styling */}
        <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        .animate-fade-in {
          animation: fade-in 1s ease-out forwards;
        }
      `}</style>
      </section>

      <section className="bg-gray-100 py-8 sm:py-16 px-4 sm:px-6">
        <div className="inset-0"></div>
        <div className="relative container flex-col mx-auto px-6 text-center">
          <h2 className="text-2xl font-bold  font-serif  text-gray-800 mb-4 animate-fade-in">
            Boost engagement with just a click — add the Effie chatbot to your
            site instantly.
          </h2>

          <div className="flex justify-center">
            <div className="gap-4 ">
              <ul className="flex items-start flex-wrap sm:flex-nowrap justify-center  gap-8">
                {steps.map((step, index) => (
                  <Step
                    key={index}
                    icon={step.icon}
                    mainTitle={step.mainTitle}
                    contents={step.contents}
                  />
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HowToUseEffieSection;
